/* eslint-disable no-loop-func */
import React, { useState, useRef, useEffect, useLayoutEffect, createContext } from 'react';
import AppBar from '@mui/material/AppBar';
import Box from '@mui/material/Box';
import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import Checkbox from '@mui/material/Checkbox';
import CssBaseline from '@mui/material/CssBaseline';
import { DesktopDatePicker, LocalizationProvider } from '@mui/x-date-pickers'
import { DesktopTimePicker } from '@mui/x-date-pickers/DesktopTimePicker';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs'
import ja from 'dayjs/locale/ja'
import dayjs from 'dayjs'
import FormControl from '@mui/material/FormControl';
import FormControlLabel from '@mui/material/FormControlLabel';
import FormHelperText from '@mui/material/FormHelperText';
import Grid from '@mui/material/Grid';
import IconButton from '@mui/material/IconButton';
import MenuItem from '@mui/material/MenuItem';
import Select from '@mui/material/Select';
import Stepper from '@mui/material/Stepper';
import Step from '@mui/material/Step';
import StepLabel from '@mui/material/StepLabel';
import TextField from '@mui/material/TextField';
import Typography from '@mui/material/Typography';
import ToggleButton from '@mui/material/ToggleButton';
import ToggleButtonGroup from '@mui/material/ToggleButtonGroup';

import AddPhotoAlternateIcon from '@mui/icons-material/AddPhotoAlternate';
import ErrorIcon from '@mui/icons-material/Error';
import ExploreIcon from '@mui/icons-material/Explore';
import DeleteForeverIcon from '@mui/icons-material/DeleteForever';
import EditIcon from '@mui/icons-material/Edit';
import LowPriorityIcon from '@mui/icons-material/LowPriority';
import ReplyAllIcon from '@mui/icons-material/ReplyAll';
import UploadIcon from '@mui/icons-material/Upload';
import PdfViewerFrame from "../pdfViewerFrame.js"

import {
    InspectionContents,
    Contents,
    InspectionName,
    NomalButton,
    CautionButton,
    GrayButton,
} from '../../css/CSS.js';
import LoadingDialog from '../../Loading';
import { useForm, Controller } from "react-hook-form";
import { useNavigate, useLocation } from 'react-router-dom';
import { styled } from '@mui/material/styles';
import InspectionDeleteDialog from "../Warranty/InspectionDeleteDialog.js"; //TODO:定期点検のファイルを参照で良いか
import { ThemeProvider, createTheme } from '@mui/material/styles';
import CustomerSignature from './Signature/CustomerSignature';
import TantoSignature from './Signature/TantoSignature';

import useAuthAxios from "../../../useAuthAxios";
import Toggle, { TOGGLE_STATES } from '../../Toggle';
import InsFormFileUp from './InsFormContent/InsFormFileUp.js';

const inspectionTheme = createTheme({
    palette: {
        background: {
            default: '#f8f7f6'
        }
    },
    typography: {
        fontFamily: [
            '"Noto Sans JP"',
            'Roboto',
            '"Helvetica"',
            'Arial',
            'sans-serif',
        ].join(','),
    },
    components: {
        MuiFormHelperText: {
            styleOverrides: {
                root: {
                    fontWeight: "bold",
                    fontSize: "1.2rem",
                    backgroundColor: "#ffe6e6",
                    padding: "4px 8px",
                    borderRadius: 4,
                    marginTop: 4,
                    whiteSpace: "normal", // ← 折り返し有効化
                    overflow: "visible",  // ← はみ出しを許可
                }
            }
        }
    }
})

const Steppers = styled(Stepper)({
    backgroundColor: "#FFFFCC",
    padding: "10px",
    borderRadius: "10px",
    transform: "scale(1.1)"
});

const PreviewImg = styled('img')({
});

export const WarrantyInitialInputData = {
    visitDate: '',
    tenkenTimeFrom: '00:00',
    tenkenTimeTo: '00:00',
    deleverDate: '',
    address: '',
    kojiCD: '',
    customerCD: '',
    customerName: '',
    tenkenShiten: '',
    tenkenShitenCD: '',
    tenkenTanto: '',
    customerSign: '',
    tantoSign: '',
    honjitsuSagyo: '0',
    sagyocontent: '0',
    hokkaidoshiten: '0',
    touhokushiten: '0',
    kitakanntoshiten: '0',
    tibashiten: '0',
    toukyoushiten: '0',
    yokohamashiten: '0',
    nagoyashite: '0',
    kansaishiten: '0',
    kyushushiten: '0',
    azumaConstructure: '0',
    bandoConstructure: '0',
    kurodaHouse: '0',
}
//入力値用context
export const UserInputData = createContext(WarrantyInitialInputData);
export default function WarrantyForm() {
    const pathName = useLocation().pathname;
    const inspectionStep = pathName.split("/").slice(-1)[0];
    const term = pathName.split("/").slice(-2)[0];

    const location = useLocation();
    const keyData = location.state?.keyData;
    let postData = {};
    const [currentState, setCurrentState] = useState(null);
    const [, setIsEffectDone] = useState(false)
    const [processing, setProcessing] = useState(false);

    const [signCustomer, setSignCustomer] = useState(false);
    const [signTanto, setSignTanto] = useState(false);
    const [tenkenPdf, setTenkenPdf] = useState("");

    const navigate = useNavigate();
    const authAxios = useAuthAxios();


    const headers = { "Authorization": "Bearer " + localStorage.getItem("Auth") };
    const getPdfHeaders = {
        "Authorization": "Bearer " + localStorage.getItem("Auth"),
        'Content-Type': 'application/pdf',
    };

    if (!keyData) {
        alert("訪問記録情報の取得に失敗しました。");
        navigate("/inspection/visitReport/customerlist/reportlist");
    }

    const [shitenList, setShitenList] = useState([])
    const [partnerList, setPartnerList] = useState([])
    const [shitenError, setShitenError] = useState(false)
    const [timeCheckError, setTimeCheckError] = useState(false)

    const [scrollState, setScrollState] = useState(0);

    const scrollStep1Ref = useRef();
    const scrollStep2Ref = useRef();
    const scrollStep3Ref = useRef();
    const scrollStep4Ref = useRef();
    const scrollStep5Ref = useRef();
    const scrollStep6Ref = useRef();
    const scrollStepShitenRef = useRef();

    const { control, handleSubmit, getValues, setValue, trigger, formState: { errors }, clearErrors, watch } = useForm({
        mode: 'onChange'
    });

    let postFlg = false;
    let clearSkipFlg = false;

    let sagyoNaiyoMaxRows = { current: 25, upcoming: 25, request: 17, confirm: 36, defaultRows: 10 };
    const createSagyoNaiyoValidator = (maxRows) => (value) => {
        if (value) {
            let count = 0
            let rowLength = 0
            let rowCount = 1
            for (let i = 0, len = value.length; i < len; i++) {
                if (value[i] === "\n") {
                    rowLength = 0
                    rowCount += 1
                } else if (value[i].match(/^[^ -~｡-ﾟ]/)) { // 全角半角判定
                    count += 1
                    rowLength += 1
                } else {
                    count += 0.5
                    rowLength += 0.5
                }
                if (rowLength > 50) {
                    return "1行50文字以内で入力してください。";
                }
                if (rowCount > maxRows) {
                    return `${maxRows}行以内で入力してください。`;
                }
            }
            if (count > 50 * maxRows) {
                return `全角${50 * maxRows}文字以内で入力してください。`;
            }
        }
    }
    const handleKeyDown = (maxRows) => (e) => {
        if (e.key !== "Enter") return;

        const lines = e.target.value.split("\n");

        if (lines.length >= maxRows) {
            e.preventDefault();
        }
    };
    const validationRules = {
        visitDate: {
            validate: (value) => {
                if (value) {
                    const formatDate = dayjs(value).format('YYYY/MM/DD')
                    if (!dayjs(formatDate, 'YYYY/MM/DD', true).isValid()) {
                        return '日付形式が間違っています。'
                    }
                }
                if (postFlg === true) {
                    if (!value || value === "") {
                        return '訪問日を入力してください。'
                    }
                }
            }
        },
        tenkenTimeFrom: {
            validate: (value) => {
                if (value) {
                    const formatTimeFrom = dayjs(value).format('HH:mm')
                    if (!dayjs(formatTimeFrom, 'HH:mm', true).isValid()) {
                        return '時間形式が間違っています。'
                    }
                    if (value.getMinutes() % 15 !== 0) {
                        return '15分単位で指定してください。'
                    }
                    if (getValues('tenkenTimeTo')) {
                        const compareTime = new Date(getValues('tenkenTimeTo'));
                        if (new Date(value) > compareTime) {
                            return '時間の指定が正しくありません。'
                        }
                        if (clearSkipFlg === false) {
                            if (errors?.tenkenTimeTo?.message === '時間の指定が正しくありません。') {
                                clearErrors("tenkenTimeTo")
                            }
                        }
                    }
                }
                if (postFlg === true) {
                    if (!value || value === "") {
                        return '点検時間を入力してください。'
                    }
                }
            }
        },
        tenkenTimeTo: {
            validate: (value) => {
                if (value) {
                    const formatTimeTo = dayjs(value).format('HH:mm')
                    if (!dayjs(formatTimeTo, 'HH:mm', true).isValid()) {
                        return '時間形式が間違っています。'
                    }
                    if (value.getMinutes() % 15 !== 0) {
                        return '15分単位で指定してください。'
                    }
                    if (getValues('tenkenTimeFrom')) {
                        const compareTime = new Date(getValues('tenkenTimeFrom'));
                        if (new Date(value) < compareTime) {
                            return '時間の指定が正しくありません。'
                        }
                        if (clearSkipFlg === false) {
                            if (errors?.tenkenTimeFrom?.message === '時間の指定が正しくありません。') {
                                clearErrors("tenkenTimeFrom")
                            }
                        }
                    }
                }
                if (postFlg === true) {
                    if (!value || value === "") {
                        return '点検時間を入力してください。'
                    }
                }
            }
        },
        customerName: {
            validate: (value) => {
                if (value) {
                    let counter = 0
                    for (let i = 0; i < value.length; i++) {
                        if (value[i].match(/^[^ -~｡-ﾟ]/)) {
                            counter += 2
                        } else {
                            counter += 1
                        }
                        if (counter > 100) {
                            return '全角で50文字、半角で100文字以内で入力してください。'
                        }
                    }
                }
                if (postFlg === true) {
                    if (!value || value === "") {
                        return 'お客様邸名を入力してください。'
                    }
                }
            }
        },
        address: {
            validate: (value) => {
                if (value) {
                    let counter = 0
                    for (let i = 0; i < value.length; i++) {
                        if (value[i].match(/^[^ -~｡-ﾟ]/)) {
                            counter += 2
                        } else {
                            counter += 1
                        }
                        if (counter > 80) {
                            return '全角で40文字、半角で80文字以内で入力してください。'
                        }
                    }
                }
                if (postFlg === true) {
                    if (!value || value === "") {
                        return '住所を入力してください。'
                    }
                }
            }
        },
        tenkenTanto: {
            validate: (value) => {
                if (value) {
                    let counter = 0
                    for (let i = 0; i < value.length; i++) {
                        if (value[i].match(/^[^ -~｡-ﾟ]/)) {
                            counter += 2
                        } else {
                            counter += 1
                        }
                        if (counter > 24) {
                            return '全角で12文字、半角で24文字以内で入力してください。'
                        }
                    }
                }
                if (postFlg === true) {
                    if (!value || value === "") {
                        return '点検実施者を入力してください。'
                    }
                }
            }
        },
        kenmei: {
            validate: (value) => {
                if (value) {
                    let counter = 0
                    for (let i = 0; i < value.length; i++) {
                        if (value[i].match(/^[^ -~｡-ﾟ]/)) {
                            counter += 2
                        } else {
                            counter += 1
                        }
                        if (counter > 80) {
                            return '全角で40文字、半角で80文字以内で入力してください。'
                        }
                    }
                }
                if (postFlg === true) {
                    if (!value || value === "") {
                        return '件名を入力してください。'
                    }
                }
            }
        },
        sagyoNaiyoCurrent: {
            validate: createSagyoNaiyoValidator(sagyoNaiyoMaxRows.current)
        },
        sagyoNaiyoUpcoming: {
            validate: createSagyoNaiyoValidator(sagyoNaiyoMaxRows.upcoming)
        },
        sagyoNaiyoRequest: {
            validate: createSagyoNaiyoValidator(sagyoNaiyoMaxRows.request)
        },
        sagyoNaiyoConfirm: {
            validate: createSagyoNaiyoValidator(sagyoNaiyoMaxRows.confirm)
        },
        requestDate: {
            validate: (value) => {
                if (value) {
                    const formatDate = dayjs(value).format('YYYY/MM/DD')
                    if (!dayjs(formatDate, 'YYYY/MM/DD', true).isValid()) {
                        return '日付形式が間違っています'
                    }
                }
                if (postFlg === true) {
                    if (!value || value === "") {
                        return '日付を入力してください。'
                    }
                }
            }
        },
        requestPerson: {
            validate: (value) => {
                if (value) {
                    let counter = 0
                    for (let i = 0; i < value.length; i++) {
                        if (value[i].match(/^[^ -~｡-ﾟ]/)) {
                            counter += 2
                        } else {
                            counter += 1
                        }
                        if (counter > 24) {
                            return '全角で12文字、半角で24文字以内で入力してください。'
                        }
                    }
                }
                if (postFlg === true) {
                    if (!value || value === "") {
                        return '受付者を入力してください。'
                    }
                }
            }
        },
    }

    //ナビバー項目
    const [activeStep, setActiveStep] = useState(0);
    let PageSteps = [];

    //watchを使用
    const watchValues = watch(["tenkenTimeFrom", "tenkenTimeTo"])
    useEffect(() => {
        if (errors.tenkenTimeFrom || errors.tenkenTimeTo) {
            setTimeCheckError(true)
        } else {
            setTimeCheckError(false)
        }
    }, [watchValues])


    if (inspectionStep === 'edit') {
        PageSteps = ["外観添付", "依頼内容", "確認した内容", "本日の作業内容", "今後のスケジュールと作業内容", "添付ファイル",]
    } else if (inspectionStep === 'confirm') {
        PageSteps = ["入力画面", "確認・署名画面",]
    }


    const isShitenSelected = () => {
        for (let i = 0; i < shitenList.length; i++) {
            if (getValues(shitenList[i].shitenId) === "1") {
                return true
            }
        }
        return false
    }

    const onSubmit = async (action) => {
        if (!keyData.canEdit) {
            let navString = "";
            if (action === "post") {
                navString = term + "/customerlist";
            } else if (action === "next") {
                navString = term + "/confirm"
            } else if (action === "save") {
                navString = term + "/" + term
            } else if (action === "back") {
                navString = term + "/edit"
            }
            navigate("/inspection/" + navString, {
                state: {
                    keyData: keyData,
                }
            });
        } else {
            clearSkipFlg = true;
            if (action === "next") {
                postFlg = true;
            } else {
                postFlg = false;
            }
            const isValid = await trigger();
            if (isValid) {
                doneSubmit(action);
            } else {
                scrollStep1Ref.current.scrollIntoView({ behavior: "smooth", block: "center" })
                clearSkipFlg = false;
                alert("入力内容に不備があります")
                return
            }
        }
    }

    const trimTrailingNewlines = (str) => {
        return str.replace(/\n+$/, '');
    };

    const doneSubmit = (action) => {
        clearSkipFlg = false;
        if (!isShitenSelected() && postFlg) {
            scrollStepShitenRef.current.scrollIntoView({ behavior: "smooth", block: "center" })
            alert("担当部門は一つ以上選択してください")
            setShitenError(true)
            return
        } else {
            setShitenError(false)
        }
        let mergeData = JSON.parse(JSON.stringify(currentState))
        mergeData.visitDate = formatDateToString(getValues('visitDate'))
        mergeData.tenkenTimeFrom = formatTimeToString(getValues('tenkenTimeFrom'))
        mergeData.tenkenTimeTo = formatTimeToString(getValues('tenkenTimeTo'))
        mergeData.customerName = getValues('customerName')
        mergeData.address = getValues('address')
        mergeData.tenkenShitenCD = getValues('tenkenShitenCD')
        shitenList.forEach((list) => {
            if (list.shitenCD === getValues('tenkenShitenCD')) {
                mergeData.tenkenShiten = list.shitenName
            }
        })
        mergeData.tenkenTanto = getValues('tenkenTanto')

        mergeData.kenmei = getValues('kenmei') ? getValues('kenmei') : ''

        mergeData.requestContent = getValues('requestContent') ? trimTrailingNewlines(getValues('requestContent')) : ''
        mergeData.requestDate = formatDateToString(getValues('requestDate'))
        mergeData.requestPerson = getValues('requestPerson') ? getValues('requestPerson') : ''

        mergeData.comfirmContent = getValues('comfirmContent') ? trimTrailingNewlines(getValues('comfirmContent')) : ''

        mergeData.todayContent = getValues('todayContent') ? trimTrailingNewlines(getValues('todayContent')) : ''
        mergeData.confirmCheck = getValues('confirmCheck') ? getValues('confirmCheck') : '0'
        mergeData.repairCheck = getValues('repairCheck') ? getValues('repairCheck') : '0'
        mergeData.repairTatiai = getValues('repairTatiai') ? getValues('repairTatiai') : '0'
        mergeData.csCheck = getValues('csCheck') ? getValues('csCheck') : '0'
        mergeData.otherCheck = getValues('otherCheck') ? getValues('otherCheck') : '0'

        mergeData.schduleContent = getValues('schduleContent') ? trimTrailingNewlines(getValues('schduleContent')) : ''

        //添付されたファイルをカウント
        let fileCountBesshiRecord = 0
        let fileCountBesshiZumen = 0
        attachedImage.forEach(attachedImageElement => {
            if (attachedImageElement.Type === 0) {
                fileCountBesshiZumen++
            }
            if (attachedImageElement.Type === 1) {
                fileCountBesshiRecord++
            }
        })

        attachedPdf.forEach(attachedPdfElement => {
            if (attachedPdfElement.Type === 0) {
                fileCountBesshiZumen++
            }
            if (attachedPdfElement.Type === 1) {
                fileCountBesshiRecord++
            }
        })

        mergeData.besshiRecord = getValues('besshiRecord') ? getValues('besshiRecord').toString() : '0'
        mergeData.besshiRecordSheets = getValues('besshiRecordSheets') ? fileCountBesshiRecord.toString() : '0'
        mergeData.besshizumen = getValues('besshizumen') ? getValues('besshizumen').toString() : '0'
        mergeData.besshiZumenSheets = getValues('besshiZumenSheets') ? fileCountBesshiZumen.toString() : '0'

        mergeData.hokkaidoshiten = getValues('hokkaidoshiten') ? getValues('hokkaidoshiten') : '0'
        mergeData.touhokushiten = getValues('touhokushiten') ? getValues('touhokushiten') : '0'
        mergeData.kitakanntoshiten = getValues('kitakanntoshiten') ? getValues('kitakanntoshiten') : '0'
        mergeData.tibashiten = getValues('tibashiten') ? getValues('tibashiten') : '0'
        mergeData.toukyoushiten = getValues('toukyoushiten') ? getValues('toukyoushiten') : '0'
        mergeData.yokohamashiten = getValues('yokohamashiten') ? getValues('yokohamashiten') : '0'
        mergeData.nagoyashiten = getValues('nagoyashiten') ? getValues('nagoyashiten') : '0'
        mergeData.kansaishiten = getValues('kansaishiten') ? getValues('kansaishiten') : '0'
        mergeData.kyushushiten = getValues('kyushushiten') ? getValues('kyushushiten') : '0'
        mergeData.azumaConstructure = getValues('azumaConstructure') ? getValues('azumaConstructure') : '0'
        mergeData.bandoConstructure = getValues('bandoConstructure') ? getValues('bandoConstructure') : '0'
        mergeData.kurodaHouse = getValues('kurodaHouse') ? getValues('kurodaHouse') : '0'

        postData = mergeData
        setCurrentState(mergeData)

        if (action === "post") {
            setProcessing(true);
            authAxios
                .post('api/visitReport/detail/' + keyData.kojiCD + '/' + keyData.rptShubetsu + '?inputType=1&reportSeqNo=' + keyData.rptSeq
                    , postData)
                .then(response => {
                    if (response.status === 200) {
                        setProcessing(false);
                        navigate("/inspection/visitReport/customerlist");
                    }
                }).catch((response) => {
                    alert("作成中のデータの登録に失敗しました。", response.body);
                    setProcessing(false);
                })
        } else {
            setProcessing(true);
            authAxios
                .post('api/visitReport/detail/' + keyData.kojiCD + '/' + keyData.rptShubetsu + '?inputType=1&reportSeqNo=' + keyData.rptSeq
                    , postData)
                .then(response => {
                    if (response.status === 200) {
                        authAxios
                            .get('api/visitReport/detail/' + keyData.kojiCD + "/" + keyData.rptShubetsu + '/' + keyData.rptSeq)
                            .then(response => {
                                if (response.status === 200) {
                                    let navString = "";
                                    setScrollState(0)
                                    setActiveStep(999)
                                    if (action === "next") {
                                        navString = term + "/confirm"
                                    } else if (action === "save") {
                                        navString = term + "/" + term
                                    } else if (action === "back") {
                                        navString = term + "/edit"
                                    }
                                    navigate("/inspection/" + navString, {
                                        state: {
                                            keyData: keyData,
                                        }
                                    });

                                    setProcessing(false);
                                }
                            }).catch((response) => {
                                alert("作成中のデータの取得に失敗しました。", response.body);
                                setProcessing(false);
                            })
                    }
                }).catch((response) => {
                    alert("作成中のデータの登録に失敗しました。", response.body);
                    setProcessing(false);
                })
        }
    }

    //入力項目初期補完
    useEffect(() => {
        setIsEffectDone(true);
        setProcessing(true);
        authAxios
            .get('api/inspection/inspectionVendor/offices', { headers })
            .then(response => {
                if (response.status === 200) {
                    const officeList = JSON.parse((JSON.stringify(response.data)));
                    setShitenList(officeList.shitenInfo)
                    setPartnerList(officeList.partnerInfo)
                    authAxios
                        .get('api/visitReport/detail/' + keyData.kojiCD + "/" + keyData.rptShubetsu + '/' + keyData.rptSeq, { headers })
                        .then(response => {
                            if (response.status === 200) {
                                const formatData = JSON.parse((JSON.stringify(response.data)));
                                let getFormdata = null
                                getFormdata = formatData

                                if (getFormdata) {
                                    setCurrentState(getFormdata)
                                    Object.entries(getFormdata).forEach(([key, value]) => {
                                        if (value === null) {
                                            if (key === "tenkenShitenCD") {
                                                setValue(key, officeList?.shitenInfo[0]?.shitenCD)
                                            }
                                        } else {
                                            setValue(key, value)
                                        }
                                    })
                                    const setTenkenTime = async () => {
                                        if (getFormdata?.visitDate) {
                                            const visitDate = new Date(getFormdata.visitDate);
                                            setValue('visitDate', visitDate)
                                        };
                                        if (getFormdata?.tenkenTimeFrom) {
                                            const tenkenTimeFromArray = getFormdata.tenkenTimeFrom.split(':')
                                            const tenkenTimeFrom = new Date();
                                            tenkenTimeFrom.setHours(parseInt(tenkenTimeFromArray[0]))
                                            tenkenTimeFrom.setMinutes(parseInt(tenkenTimeFromArray[1]))
                                            setValue('tenkenTimeFrom', tenkenTimeFrom)
                                        };
                                        if (getFormdata?.tenkenTimeTo) {
                                            const tenkenTimeFromArray = getFormdata.tenkenTimeTo.split(':')
                                            const tenkenTimeTo = new Date();
                                            tenkenTimeTo.setHours(parseInt(tenkenTimeFromArray[0]))
                                            tenkenTimeTo.setMinutes(parseInt(tenkenTimeFromArray[1]))
                                            setValue('tenkenTimeTo', tenkenTimeTo)
                                        };
                                    };
                                    setTenkenTime();
                                }
                                setProcessing(false);
                                setIsEffectDone(false);
                            }
                        }).catch((response) => {
                            alert("データの取得に失敗しました。", response.body);
                            setProcessing(false);
                            setIsEffectDone(false);
                        })
                }
            }).catch((response) => {
                alert("事業所一覧の取得に失敗しました。", response.body);
                setProcessing(false);
                setIsEffectDone(false);
            })
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])


    //チェックボックス対応
    const handleCheckboxOnChange = (status, formID, classType) => {
        if (status) {
            setValue(formID, '1')
            if (classType === "shiten") {
                setShitenError(false)
            }
        } else {
            setValue(formID, '0')
        }
    }

    const [namePlateImage, setNamePlateImage] = useState(null);
    const [namePlate, setNamePlate] = useState(null);
    const [delDialog, setDelDialog] = useState(false);
    const [npProcessing, setNpProcessing] = useState(false);
    const [locateInfo, setLocateInfo] = useState("");
    const [mapLink, setMapLink] = useState(null);
    const inputNPRef = useRef("");

    const [attachedImage, setAttachedImage] = useState([]);
    const [previewImgIndex, setPreviewImgIndex] = useState(0)
    const [previewImgDialog, setPreviewImgDialog] = useState(false)
    const [previewImgDelDialog, setPreviewImgDelDialog] = useState(false)

    const [attachedPdf, setAttachedPdf] = useState([]);
    const [openPdf, setOpenPdf] = useState(false)
    const [selectPdfIndex, setSelectPdfIndex] = useState(0)
    const [previewPdfDelDialog, setPreviewPdfDelDialog] = useState(false)
    const [prevDelIndex, setPrevDelIndex] = useState(0)

    const [uploadFlag, setUploadFlag] = useState(false);
    const [inputNPKey, setInputNPKey] = useState(0);

    const namePlateExts = ['jpg', 'jpeg', 'heic']
    //表札・外観登録
    const onNPInputChange = (e) => {
        if (!e.target.files || e.target.files.length === 0) return;
        const fileObject = e.target.files[0];
        if (!namePlateExts.includes(fileObject.name.split('.').pop().toLowerCase())) {
            setInputNPKey((prevKey) => prevKey + 1);
            alert("jpg/jpeg、heicのいずれかのファイルを選択して下さい。")
            return;
        }
        let fileNameLengthCounter = 0;
        for (let i = 0; i < fileObject.name.length; i++) {
            if (fileObject.name[i].match(/^[^ -~｡-ﾟ]/)) {
                fileNameLengthCounter += 2
            } else {
                fileNameLengthCounter += 1
            }
            if (fileNameLengthCounter > 60) {
                alert("ファイル名は半角60文字、全角30文字以内に指定してください。")
                setInputNPKey((prevKey) => prevKey + 1);
                return
            }
        }
        setProcessing(true);
        const body = new FormData();
        body.append("fileName", fileObject.name);
        body.append("file", fileObject);
        authAxios
            .post('api/visitReport/' + keyData.kojiCD + '/' + keyData.rptShubetsu + '/' + keyData.rptSeq + '/PosFile'
                , body, { headers })
            .then(response => {
                if (response.status === 200) {
                    authAxios
                        .get('api/visitReport/' + keyData.kojiCD + '/' + keyData.rptShubetsu + '/' + keyData.rptSeq + '/PosFile')
                        .then(response => {
                            if (response.status === 200) {
                                const registeredNPData = JSON.parse((JSON.stringify(response.data)));
                                if (registeredNPData.placeInfoFileData64) {
                                    if (registeredNPData.latitude && registeredNPData.longtitude) {
                                        setLocateInfo(registeredNPData.latitude + ', ' + registeredNPData.longtitude)
                                        setMapLink('https://www.google.com/maps?q=' + registeredNPData.latitude + ', ' + registeredNPData.longtitude)
                                    } else {
                                        setLocateInfo(registeredNPData.message)
                                        setMapLink(null)
                                    }
                                    setNamePlateImage('data:image/png;base64,' + registeredNPData.placeInfoFileData64);
                                    if (registeredNPData.fileName.substring(0, registeredNPData.fileName.lastIndexOf('.')).length < 20) {
                                        setNamePlate(registeredNPData.fileName);
                                    } else {
                                        setNamePlate(registeredNPData.fileName.slice(0, 20) + '...' + registeredNPData.fileName.split('.').pop());
                                    }
                                }
                            }
                        }).catch((response) => {
                            alert("作成中の添付ファイルの取得に失敗しました。", response.body);
                            setProcessing(false);
                            setInputNPKey((prevKey) => prevKey + 1);
                        })
                    setProcessing(false);
                    setInputNPKey((prevKey) => prevKey + 1);
                }
            }).catch((response) => {
                alert("添付ファイルの登録に失敗しました。", response.body);
                setProcessing(false);
                setInputNPKey((prevKey) => prevKey + 1);
            })
    };


    useEffect(() => {
        setNpProcessing(true);
        authAxios
            .get('api/visitReport/' + keyData?.kojiCD + '/' + keyData?.rptShubetsu + '/' + keyData?.rptSeq + '/PosFile')
            .then(response => {
                if (response.status === 200) {
                    const registeredNPData = JSON.parse((JSON.stringify(response.data)));
                    if (registeredNPData.placeInfoFileData64) {
                        if (registeredNPData.latitude && registeredNPData.longtitude) {
                            setLocateInfo(registeredNPData.latitude + ', ' + registeredNPData.longtitude)
                            setMapLink('https://www.google.com/maps?q=' + registeredNPData.latitude + ', ' + registeredNPData.longtitude)
                        } else {
                            setLocateInfo(registeredNPData.message)
                            setMapLink(null)
                        }
                        setNamePlateImage('data:image/png;base64,' + registeredNPData.placeInfoFileData64);
                        if (registeredNPData.fileName.substring(0, registeredNPData.fileName.lastIndexOf('.')).length < 20) {
                            setNamePlate(registeredNPData.fileName);
                        } else {
                            setNamePlate(registeredNPData.fileName.slice(0, 20) + '...' + registeredNPData.fileName.split('.').pop());
                        }
                    }
                    setNpProcessing(false)
                }
            }).catch((response) => {
                alert("作成中の添付ファイルの取得に失敗しました。", response.body);
                setNpProcessing(false);
            })
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])


    const fileNPUpload = () => {
        inputNPRef.current.click();
    }

    //表札・外観削除確認
    const onClickNPDelete = () => {
        setDelDialog(true);
    }

    //表札・外観削除キャンセル
    const namePlateDeleteCancelClick = () => {
        setDelDialog(false);
    }

    //表札・外観削除確定
    const namePlateDeleteClick = () => {
        setProcessing(true);
        authAxios
            .delete('api/visitReport/' + keyData.kojiCD + '/' + keyData.rptShubetsu + '/' + keyData.rptSeq + '/PosFile'
                , { headers })
            .then(response => {
                if (response.status === 200) {
                    setNamePlateImage(null);
                    setNamePlate(null);
                    setLocateInfo(null);
                    setMapLink(null);
                    setInputNPKey((prevKey) => prevKey + 1);
                    setDelDialog(false);
                }
            }).catch((response) => {
                alert("添付ファイルの削除に失敗しました。", response.body);
                setProcessing(false);
            })
        setProcessing(false);
    }


    //添付ファイル一覧表示
    useEffect(() => {
        setProcessing(true);
        authAxios
            .get('api/visitReport/' + keyData?.kojiCD + '/' + keyData?.rptShubetsu + '/' + keyData?.rptSeq + '/attaches', { headers })
            .then(response => {
                if (response.status === 200) {
                    if (response.data.length === 0) {
                        setProcessing(false);
                        return;
                    }
                    const responseDataList = JSON.parse((JSON.stringify(response.data)));
                    const pdfList = [];
                    const imgList = [];
                    if (responseDataList.attachFileList.length > 0) {
                        for (let i = 0; i < responseDataList.attachFileList.length; i++) {
                            if (responseDataList.attachFileList[i].fileName.split('.').pop().toLowerCase() === 'pdf') {
                                pdfList.push({
                                    ID: responseDataList.attachFileList[i].fileId,
                                    Name: responseDataList.attachFileList[i].fileName,
                                    Type: responseDataList.attachFileList[i].attachFileType
                                });
                            } else {
                                imgList.push({
                                    ID: responseDataList.attachFileList[i].fileId,
                                    Name: responseDataList.attachFileList[i].fileName,
                                    Type: responseDataList.attachFileList[i].attachFileType,
                                    src: process.env.REACT_APP_API_URL
                                        + 'api/visitReport/' + keyData.kojiCD + '/' + keyData.rptShubetsu + '/' + keyData.rptSeq + '/'
                                        + responseDataList.attachFileList[i].fileId + '/' + responseDataList.attachFileList[i].fileName
                                });
                            }
                            if (i === responseDataList.attachFileList.length - 1) {
                                setAttachedPdf(pdfList);
                                setAttachedImage(imgList);
                                setProcessing(false);
                                setUploadFlag(false)
                            }
                        }
                    } else {//0件の場合
                        setProcessing(false);
                        setUploadFlag(false)
                    }
                }
            }).catch((response) => {
                alert("添付ファイル取得に失敗しました。", response.body);
                setProcessing(false);
                setUploadFlag(false)
            })
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [uploadFlag])

    //添付画像プレビュー表示
    const showPreviewImg = (img, index) => {
        setPreviewImgIndex(index)
        setPreviewImgDialog(true)
    }

    //添付画像プレビュー非表示
    const previewImgCancelClick = () => {
        setPreviewImgDialog(false)
    }

    //添付画像削除確認表示
    const previewImgDeleteClick = (index) => {
        setPrevDelIndex(index)
        setPreviewImgDelDialog(true)
    }

    //添付PDF表示
    const previewPdfOnClick = (index) => {
        setOpenPdf(true)
        setSelectPdfIndex(index)
    }

    React.useEffect(() => {
        if (openPdf === true) {
            window.open(process.env.REACT_APP_API_URL
                + 'api/visitReport/' + keyData?.kojiCD + '/' + keyData?.rptShubetsu + '/' + keyData?.rptSeq + '/'
                + attachedPdf[selectPdfIndex]?.ID + '/' + attachedPdf[selectPdfIndex]?.Name
            )
            setOpenPdf(false)
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [openPdf]);

    //添付PDF削除確認表示
    const previewPdfDeleteClick = (index) => {
        setPrevDelIndex(index)
        setPreviewPdfDelDialog(true)
    }

    //添付ファイル削除キャンセル
    const previewCancelBack = () => {
        setPreviewImgDelDialog(false)
        setPreviewPdfDelDialog(false)
    }


    //画面スクロール対応
    const [scrollY, setScrollY] = useState(0)
    const handleScroll = () => {
        setScrollY(window.scrollY)
    }

    useEffect(() => {
        window.addEventListener('scroll', handleScroll)
    }, [])

    useLayoutEffect(() => {
        if (inspectionStep === 'edit') {
            switch (scrollState) {
                case 0:
                    scrollStep1Ref.current.scrollIntoView({ behavior: "smooth", block: "center" })
                    break
                case 1:
                    if (scrollStep2Ref && scrollStep2Ref.current) {
                        scrollStep2Ref.current.scrollIntoView({ behavior: "smooth", block: "center" })
                    }
                    break
                case 2:
                    if (scrollStep3Ref && scrollStep3Ref.current) {
                        scrollStep3Ref.current.scrollIntoView({ behavior: "smooth", block: "center" })
                    }
                    break
                case 3:
                    if (scrollStep4Ref && scrollStep4Ref.current) {
                        scrollStep4Ref.current.scrollIntoView({ behavior: "smooth", block: "center" })
                    }
                    break
                case 4:
                    if (scrollStep5Ref && scrollStep5Ref.current) {
                        scrollStep5Ref.current.scrollIntoView({ behavior: "smooth", block: "center" })
                    }
                    break
                case 5:
                    if (scrollStep6Ref && scrollStep6Ref.current) {
                        scrollStep6Ref.current.scrollIntoView({ behavior: "smooth", block: "center" })
                    }
                    break
                default:
            }
        } else {
            scrollStep1Ref.current.scrollIntoView({ behavior: "smooth", block: "center" })
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [scrollState]);


    //項目ジャンプ機能
    const onStepClick = (index) => {
        setScrollState(index)
    }

    //ステップ自動追従
    useLayoutEffect(() => {
        if (inspectionStep === 'edit') {
            if (scrollY < 580) {
                setActiveStep(0);
            }
            if (scrollY > 580 && scrollY < 1100) {
                setActiveStep(1);
            }
            if (scrollY > 1100 && scrollY < 1620) {
                setActiveStep(2);
            }
            if (scrollY > 1620 && scrollY < 2200) {
                setActiveStep(3);
            }
            if (scrollY > 2200 && scrollY < 2800) {
                setActiveStep(4);
            }
            if (scrollY > 2800) {
                setActiveStep(5);
            }
            setScrollState(null)
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [scrollY])


    //日付フォーマット
    const formatDateToString = (date) => {
        if (date) {
            const getDate = dayjs(date).toDate();
            const year = getDate.getFullYear().toString().padStart(4, '0');
            const month = (getDate.getMonth() + 1).toString().padStart(2, '0');
            const day = getDate.getDate().toString().padStart(2, '0');
            return (year + '/' + month + '/' + day);
        } else {
            return null;
        }
    }

    //時刻フォーマット
    const formatTimeToString = (date) => {
        if (date) {
            const getDate = dayjs(date).toDate();
            const hour = getDate.getHours().toString().padStart(2, '0');
            const minutes = getDate.getMinutes().toString().padStart(2, '0');
            return (hour + ':' + minutes);
        } else {
            return null;
        }
    }

    //確認・署名サイン
    const signClose = () => {
        setProcessing(true);
        authAxios
            .get('api/visitReport/detail/' + keyData.kojiCD + "/" + keyData.rptShubetsu + '/' + keyData.rptSeq
                , headers)
            .then(response => {
                if (response.status === 200) {
                    const responseData = JSON.parse((JSON.stringify(response.data)));
                    setCurrentState(responseData);
                    setProcessing(false);
                }
                setProcessing(false);
            }).catch((response) => {
                alert("作成中データの取得に失敗しました。", response.body);
                setProcessing(false);
            })
    }


    useLayoutEffect(() => {
        window.scrollTo(0, 0);
        if (inspectionStep === 'edit') {
            setScrollState(0)
            setActiveStep(0)
        } else if (inspectionStep === 'confirm') {
            setScrollState(false)
            setActiveStep(1)
            if (currentState?.customerSign !== null) {
                setSignCustomer(true)
            } else {
                setSignCustomer(false)
            }
            if (currentState?.tantoSign !== null) {
                setSignTanto(true)
            } else {
                setSignTanto(false)
            }

            authAxios
                .get('api/visitReport/' + keyData.kojiCD + "/" + keyData.rptShubetsu + '/' + keyData.rptSeq
                    + '?signType=0', { getPdfHeaders })
                .then(response => {
                    if (response.status === 200) {
                        setTenkenPdf(process.env.REACT_APP_API_URL
                            + 'api/visitReport/' + keyData.kojiCD + "/" + keyData.rptShubetsu + '/' + keyData.rptSeq
                            + '?signType=0'
                        )
                        setProcessing(false);
                    }
                    setProcessing(false);
                }).catch((response) => {
                    alert("作成中データの取得に失敗しました。", response.body);
                    setProcessing(false);
                })
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [inspectionStep])

    useEffect(() => {
        if (inspectionStep === 'confirm') {
            if (currentState?.customerSign !== null) {
                setSignCustomer(true)
            } else {
                setSignCustomer(false)
            }
            if (currentState?.tantoSign !== null) {
                setSignTanto(true)
            } else {
                setSignTanto(false)
            }
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [currentState])

    const honjitsuSagyoList = [{ index: 1, sagyoId: 'confirmCheck', sagyoName: '確認' },
    { index: 2, sagyoId: 'repairCheck', sagyoName: '補修実施' },
    { index: 3, sagyoId: 'repairTatiai', sagyoName: '補修立会' },
    { index: 4, sagyoId: 'csCheck', sagyoName: 'CS訪問' },
    { index: 5, sagyoId: 'otherCheck', sagyoName: 'その他' }]

    const openMap = () => {
        const newWindow = window.open('about:blank', '_blank');
        if (newWindow) {
            // セキュリティ対策（openerから切り離し）
            newWindow.opener = null;

            // 少し待ってから地図へ遷移
            setTimeout(() => {
                try {
                    newWindow.location.href = mapLink;
                } catch (e) {
                    newWindow.close();
                }
            }, 200);
        }
    };

    return (
        <ThemeProvider theme={inspectionTheme}>
            <LoadingDialog load={processing || npProcessing} />
            <form onSubmit={handleSubmit(onSubmit)} >
                {inspectionStep === 'edit' ?
                    <Grid>
                        <CssBaseline />
                        <AppBar sx={{ background: '#f8f7f6', boxShadow: 0, mt: '64px' }} >
                            <InspectionContents sx={{ mb: '2.5rem' }}>
                                <Grid container columns={12} spacing={3} sx={{ alignItems: 'center' }}>
                                    <Grid item xs={2.5} >
                                        <Typography sx={{ fontSize: '1.3rem', color: '#000000', mt: 3, mb: 1 }} >
                                            工事コード:{keyData?.kojiCD}
                                        </Typography>
                                    </Grid>
                                    <Grid item xs={7} sx={{ pl: 1 }}>
                                        {keyData.thokiYuryoFlg === 1 ?
                                            <InspectionName style={{ display: 'flex', paddingBottom: 0, justifyContent: 'center', }}>
                                                <Typography sx={{ fontSize: '1.3rem', color: '#000000', mt: 3, mb: 1 }}>
                                                    <Box
                                                        component="span"
                                                        sx={{
                                                            fontSize: "1.3rem",
                                                            fontWeight: 600,
                                                            mr: 1,
                                                            color: "#2e7d32",
                                                            backgroundColor: "transparent",

                                                            cursor: "default",
                                                            userSelect: "none",
                                                        }}>
                                                        【長期優良住宅】
                                                    </Box>
                                                    {keyData?.teimei}
                                                </Typography>
                                            </InspectionName>
                                            :
                                            <InspectionName style={{ display: 'flex', paddingBottom: 0, justifyContent: 'center', }}>
                                                <Typography sx={{ fontSize: '1.3rem', color: '#000000', mt: 3, mb: 1 }}>
                                                    {keyData?.teimei}
                                                </Typography>
                                            </InspectionName>
                                        }
                                    </Grid>
                                    {!keyData.canEdit &&
                                        <Grid item xs={2.5} sx={{ pl: 1, justifyContent: "flex-end", }}>
                                            <InspectionName style={{ display: 'flex', paddingBottom: 0, justifyContent: 'center', }}>
                                                <Typography sx={{ fontSize: '1.3rem', color: '#000000', }}>
                                                    読み取り専用
                                                </Typography>
                                            </InspectionName>
                                        </Grid>
                                    }
                                </Grid>
                                <Contents component="main" sx={{ mb: 1 }}>
                                    <Steppers activeStep={activeStep} sx={{ pb: 1 }}>
                                        {PageSteps.map((label, index) => (
                                            <Step key={label} onClick={() => onStepClick(index)}>
                                                <StepLabel >{label}</StepLabel>
                                            </Step>
                                        ))}
                                    </Steppers>
                                </Contents>
                                <Grid container sx={{ justifyContent: "space-between", mt: 3 }}>
                                    <GrayButton variant="contained" color="primary" size="large" type="button"

                                        sx={{ ml: 2, mr: 2, pt: 1.5, pb: 1.5, pl: 4, pr: 4, fontSize: '1.2rem' }} onClick={() => onSubmit("post")}>
                                        <LowPriorityIcon sx={{ mr: 2, fontSize: '2rem' }} />
                                        {keyData.canEdit ? '保存して一覧へ' : '一覧へ'}
                                    </GrayButton>
                                    <Grid>
                                        <NomalButton
                                            variant="contained"
                                            color="primary"
                                            size="large"
                                            type="button"
                                            sx={{ ml: 2, mr: 2, pt: 1.5, pb: 1.5, pl: 4, pr: 4, fontSize: '1.2rem' }}
                                            onClick={() => onSubmit("next")}>
                                            <EditIcon sx={{ mr: 2, fontSize: '2rem' }} />
                                            確認・署名へ
                                        </NomalButton>
                                    </Grid>
                                </Grid>
                            </InspectionContents>
                        </AppBar>
                        <Grid sx={{ height: '15rem' }} />
                        <InspectionContents sx={{ pb: 2 }}>
                            <div
                                style={{ float: "left", clear: "both" }}
                                ref={scrollStep1Ref}
                            />
                            <Grid container rowSpacing={5}>
                                <Grid component="main" container item spacing={1} sx={{ mt: 8 }}>
                                    <Typography sx={{ pt: 3, fontSize: '2rem', }}>1　外観添付</Typography>
                                    <Grid container item direction="row" sx={{ mt: 1.5, ml: 3, mr: 3 }} spacing={0} >
                                        <InspectionDeleteDialog
                                            contentType={0}
                                            name={namePlate}
                                            src={namePlateImage}
                                            open={delDialog}
                                            cancelClick={namePlateDeleteCancelClick}
                                            deleteClick={namePlateDeleteClick} />
                                        <Grid item xs={12} md={7}>
                                            <Typography sx={{ mx: 3, mr: 3, fontSize: '1.5rem' }}>
                                                表札または外観の撮影画像を添付してください。<br />
                                                画像ファイルより自動的に位置情報が表示されます。<br />
                                                <br />
                                            </Typography>
                                            <Typography sx={{ mx: 3, mr: 3, fontSize: '1.0rem' }}>
                                                ※iPadで撮影する場合、位置情報をONにし 4G/5G 回線で撮影してください。<br />
                                                ※モバイルPCで撮影する場合、PCの位置情報をONにしiPhoneとテザリングしてPCのカメラアプリで撮影してください。<br />
                                                <br />
                                            </Typography>
                                            <Grid container direction="row" sx={{ alignItems: "center", py: 2, }} >
                                                {namePlate ?
                                                    <CautionButton variant="contained" size="large" onClick={onClickNPDelete} disabled={!keyData.canEdit}
                                                        sx={{ ml: 2, mr: 2, pt: 1.5, pb: 1.5, pl: 4, pr: 4, fontSize: '1.2rem' }} >
                                                        <DeleteForeverIcon sx={{ mr: 2, fontSize: '2rem' }} />ファイルを削除
                                                    </CautionButton>
                                                    :
                                                    <NomalButton variant="contained" size="large" onClick={fileNPUpload} disabled={!keyData.canEdit}
                                                        sx={{ ml: 2, mr: 2, pt: 1.5, pb: 1.5, pl: 4, pr: 4, fontSize: '1.2rem' }} >
                                                        <AddPhotoAlternateIcon sx={{ mr: 2, fontSize: '2rem' }} />ファイルを選択
                                                    </NomalButton>
                                                }
                                                <Typography align='center' sx={{ ml: 5, my: 1 }}>
                                                    <ErrorIcon sx={{ mr: 0.5, color: '#d32f2f' }}
                                                        style={{ verticalAlign: 'middle' }} />
                                                    jpg/jpeg、heicファイルのみです
                                                </Typography>
                                            </Grid>
                                            {/*<Grid container direction="row" sx={{ pt: 1, pb: 1, alignItems: "center" }}>*/}
                                            {/*    <Typography sx={{ ml: '1%', mr: '1%', width: '14%', fontSize: '1.2rem' }}>ファイル名</Typography>*/}
                                            {/*    <Typography sx={{ pt: 1.5, pb: 1.5, pl: '1%', pr: '1%', border: 1, width: '80%', height: 55, fontSize: '1.2rem', backgroundColor: '#f5f8fa' }}>{namePlate}</Typography>*/}
                                            {/*</Grid>*/}
                                            <Grid container direction="row" sx={{ pt: 1, pb: 1, alignItems: "center" }}>
                                                <Typography sx={{ ml: '1%', mr: '1%', width: '15%', fontSize: '1.2rem' }} align="center">位置情報</Typography>
                                                <Typography sx={{ pt: 1.5, pb: 1.5, pl: '1%', border: 1, width: '69%', minHeight: 55, height: 'auto', fontSize: '1.2rem', backgroundColor: '#f5f8fa' }}>{locateInfo}</Typography>
                                                <Grid container sx={{ justifyContent: "center", alignItems: "center", width: '10%' }}>
                                                    {mapLink ?
                                                        <IconButton onClick={openMap} >
                                                            <ExploreIcon sx={{ fontSize: '3rem', color: '#52B833' }} />
                                                        </IconButton>
                                                        :
                                                        <ExploreIcon sx={{ fontSize: '3rem', color: '#C0C0C0' }} />
                                                    }
                                                </Grid>
                                            </Grid>
                                        </Grid>
                                        <Grid container item xs={12} md={5}
                                            sx={{
                                                bgcolor: '#D8DBDD',
                                                height: 350,
                                                alignItems: "center",
                                                justifyContent: "center",
                                            }}>
                                            <input
                                                type="file"
                                                hidden
                                                ref={inputNPRef}
                                                key={inputNPKey}
                                                accept=".jpg,.jpeg,.heic"
                                                onChange={onNPInputChange}
                                                id="namePlate" />
                                            <PreviewImg src={namePlateImage} alt=''
                                                sx={{ maxHeight: '100%', maxWidth: '100%' }} />
                                        </Grid>
                                    </Grid >
                                </Grid >

                                <FormControl disabled={!keyData.canEdit}  >
                                    <fieldset disabled={!keyData.canEdit} style={{ border: 0, margin: 0, padding: 0 }} >
                                        <Grid container item rowSpacing={5} spacing={3} component="main"
                                            sx={{ pt: 8 }}>

                                            <Grid container item xs="auto">
                                                <Typography sx={{ fontSize: '1.5rem', mr: 1, pt: 0.5 }}>訪問日</Typography>
                                                <Controller
                                                    name="visitDate"
                                                    control={control}
                                                    defaultValue=""
                                                    rules={validationRules.visitDate}
                                                    render={({ field: { onChange, value, ...restField }, formState: { errors } }) => (
                                                        <LocalizationProvider dateAdapter={AdapterDayjs} adapterLocale={ja}>
                                                            <DesktopDatePicker
                                                                {...restField}
                                                                inputFormat={'YYYY/MM/DD'}
                                                                value={value || ''}
                                                                onChange={(newDateValue) => {
                                                                    if (newDateValue) {
                                                                        onChange(dayjs(newDateValue).toDate())
                                                                    } else {
                                                                        onChange(newDateValue)
                                                                    }
                                                                }}
                                                                renderInput={(params) => (
                                                                    <TextField
                                                                        {...params}
                                                                        inputProps={{
                                                                            ...params.inputProps,
                                                                            maxLength: 10,
                                                                            style: { fontSize: '1.5rem', backgroundColor: '#f5f8fa' }
                                                                        }}
                                                                        variant="standard"
                                                                        label=""
                                                                        error={errors.visitDate ? true : false}
                                                                        helperText={errors.visitDate?.message}
                                                                    />
                                                                )}
                                                            />
                                                        </LocalizationProvider>
                                                    )}
                                                />
                                            </Grid>

                                            <Grid container item xs="auto">
                                                <Grid item >
                                                    <Typography sx={{ fontSize: '1.5rem', mr: 1, pt: 0.5 }}>点検時間</Typography>
                                                </Grid>
                                                <Grid item >
                                                    <Grid container item >
                                                        <Controller
                                                            name="tenkenTimeFrom"
                                                            control={control}
                                                            defaultValue=""
                                                            rules={validationRules.tenkenTimeFrom}
                                                            render={({ field: { onChange, value, ...restField }, formState: { errors } }) => (
                                                                <LocalizationProvider dateAdapter={AdapterDayjs} adapterLocale={ja}>
                                                                    <DesktopTimePicker
                                                                        {...restField}
                                                                        inputFormat={'HH:mm'}
                                                                        value={value || ''}
                                                                        onChange={(newDateValue) => {
                                                                            if (newDateValue) {
                                                                                onChange(dayjs(newDateValue).toDate())
                                                                            } else {
                                                                                onChange(newDateValue)
                                                                            }
                                                                        }}
                                                                        minutesStep={15}
                                                                        renderInput={(params) => (
                                                                            <TextField
                                                                                {...params}
                                                                                inputProps={{
                                                                                    ...params.inputProps,
                                                                                    maxLength: 5,
                                                                                    style: { fontSize: '1.5rem', backgroundColor: '#f5f8fa' }
                                                                                }}
                                                                                variant="standard"
                                                                                label=""
                                                                                sx={{ width: 120 }}
                                                                                error={errors.tenkenTimeFrom ? true : false}
                                                                            />
                                                                        )}
                                                                    />
                                                                </LocalizationProvider>
                                                            )}
                                                        />
                                                        <Typography sx={{ pt: 0.5, pr: 1.5, pl: 1.5, fontSize: '1.5rem' }}>～</Typography>
                                                        <Controller
                                                            name="tenkenTimeTo"
                                                            control={control}
                                                            defaultValue=""
                                                            rules={validationRules.tenkenTimeTo}
                                                            render={({ field: { onChange, value, ...restField }, formState: { errors } }) => (
                                                                <LocalizationProvider dateAdapter={AdapterDayjs} adapterLocale={ja}>
                                                                    <DesktopTimePicker
                                                                        {...restField}
                                                                        inputFormat={'HH:mm'}
                                                                        value={value || ''}
                                                                        onChange={(newDateValue) => {
                                                                            if (newDateValue) {
                                                                                onChange(dayjs(newDateValue).toDate())
                                                                            } else {
                                                                                onChange(newDateValue)
                                                                            }
                                                                        }}
                                                                        minutesStep={15}
                                                                        renderInput={(params) => (
                                                                            <TextField
                                                                                {...params}
                                                                                inputProps={{
                                                                                    ...params.inputProps,
                                                                                    maxLength: 5,
                                                                                    style: { fontSize: '1.5rem', backgroundColor: '#f5f8fa' }
                                                                                }}
                                                                                variant="standard"
                                                                                label=""
                                                                                sx={{ width: 120 }}
                                                                                error={errors.tenkenTimeTo ? true : false}
                                                                            />
                                                                        )}
                                                                    />
                                                                </LocalizationProvider>
                                                            )}
                                                        />
                                                    </Grid>
                                                    <Grid container item >
                                                        {timeCheckError &&
                                                            <FormHelperText sx={{ ml: 0 }} error>
                                                                {errors.tenkenTimeFrom?.message ?
                                                                    errors.tenkenTimeFrom?.message :
                                                                    errors.tenkenTimeTo?.message}
                                                            </FormHelperText>
                                                        }
                                                    </Grid>
                                                </Grid>
                                            </Grid>

                                            <Grid container item xs={12}>
                                                <Controller
                                                    name="customerName"
                                                    control={control}
                                                    defaultValue=""
                                                    rules={validationRules.customerName}
                                                    render={({ field, fieldState }) => (
                                                        <TextField
                                                            {...field}
                                                            inputProps={{
                                                                maxLength: 100,
                                                                style: { fontSize: '1.5rem', backgroundColor: '#f5f8fa' }
                                                            }}
                                                            variant="standard"
                                                            error={fieldState.invalid}
                                                            sx={{ width: "90%" }}
                                                            helperText={fieldState.error?.message} />
                                                    )}
                                                />
                                                <Typography sx={{ fontSize: '1.5rem', pt: 0.5, }} >様邸</Typography>
                                            </Grid>

                                            <Grid container item xs={12}>
                                                <Typography sx={{ fontSize: '1.5rem', mr: 1, pt: 0.5 }} >住所</Typography>
                                                <Controller
                                                    name="address"
                                                    control={control}
                                                    defaultValue=""
                                                    rules={validationRules.address}
                                                    render={({ field, fieldState }) => (
                                                        <TextField
                                                            {...field}
                                                            inputProps={{
                                                                maxLength: 80,
                                                                style: { fontSize: '1.5rem', backgroundColor: '#f5f8fa' }
                                                            }}
                                                            variant="standard"
                                                            error={fieldState.invalid}
                                                            sx={{ width: "90%" }}
                                                            helperText={fieldState.error?.message} />
                                                    )}
                                                />
                                            </Grid>

                                            <Grid container item xs="auto">
                                                <Typography sx={{ fontSize: '1.5rem', mr: 1, pt: 0.5 }}>点検支店</Typography>
                                                <Controller
                                                    name='tenkenShitenCD'
                                                    control={control}
                                                    defaultValue=""
                                                    rules={validationRules.tenkenShitenCD}
                                                    render={({ field, fieldState }) => (
                                                        <FormControl error={fieldState.invalid}>
                                                            {shitenList &&
                                                                <Select
                                                                    variant="standard"
                                                                    sx={{
                                                                        '& .MuiInputBase-input': {
                                                                            fontSize: '1.5rem',
                                                                            pl: '0.5rem',
                                                                            pt: '0.5rem',
                                                                            backgroundColor: '#f5f8fa',
                                                                            color: (theme) => theme.palette.text.primary + ' !important',
                                                                            WebkitTextFillColor: (theme) => theme.palette.text.primary + ' !important',
                                                                        },
                                                                        "& .MuiSelect-select.Mui-disabled": {
                                                                            color: (theme) => theme.palette.text.primary + ' !important',
                                                                            WebkitTextFillColor: (theme) => theme.palette.text.primary + ' !important',
                                                                        },
                                                                        width: 200
                                                                    }}
                                                                    {...field}
                                                                    disabled={!keyData?.canEdit}
                                                                >
                                                                    {shitenList.map((row, index) => {
                                                                        return (
                                                                            <MenuItem key={index}
                                                                                value={row.shitenCD}
                                                                            //value={row.shitenName}
                                                                            >{row.shitenName}</MenuItem>
                                                                        );
                                                                    })}
                                                                </Select>
                                                            }
                                                        </FormControl>
                                                    )}
                                                />
                                            </Grid>

                                            <Grid container item xs={8}>
                                                <Typography sx={{ fontSize: '1.5rem', mr: 1, pt: 0.5 }}>点検実施者</Typography>
                                                <Controller
                                                    name="tenkenTanto"
                                                    control={control}
                                                    defaultValue=""
                                                    rules={validationRules.tenkenTanto}
                                                    render={({ field, fieldState }) => (
                                                        <TextField
                                                            {...field}
                                                            inputProps={{
                                                                maxLength: 24,
                                                                style: { fontSize: '1.5rem', backgroundColor: '#f5f8fa' }
                                                            }}
                                                            variant="standard"
                                                            error={fieldState.invalid}
                                                            sx={{ width: "60%" }}
                                                            helperText={fieldState.error?.message} />
                                                    )}
                                                />
                                            </Grid>
                                        </Grid>
                                    </fieldset>
                                </FormControl >
                                <FormControl disabled={!keyData.canEdit} fullWidth>
                                    <fieldset disabled={!keyData.canEdit} style={{ border: 0, margin: 0, padding: 0 }} >
                                        <Grid container component="main" sx={{ mt: 8 }}>
                                            <Grid container item xs={12}>
                                                <Typography sx={{ fontSize: '1.7rem', mr: 1, pt: 0.5 }}>件名</Typography>

                                                <Controller
                                                    name="kenmei"
                                                    control={control}
                                                    defaultValue=""
                                                    rules={validationRules.kenmei}
                                                    render={({ field, fieldState }) => (
                                                        <TextField
                                                            {...field}
                                                            inputProps={{
                                                                maxLength: 80,
                                                                style: { fontSize: '1.5rem', backgroundColor: '#f5f8fa' }
                                                            }}
                                                            variant="standard"
                                                            error={fieldState.invalid}
                                                            sx={{ width: "90%" }}
                                                            helperText={fieldState.error?.message} />
                                                    )}
                                                />
                                            </Grid>
                                        </Grid>
                                    </fieldset>
                                </FormControl >
                                <FormControl disabled={!keyData.canEdit}  >
                                    <fieldset disabled={!keyData.canEdit} style={{ border: 0, margin: 0, padding: 0 }} >
                                        <Grid container component="main" sx={{ mt: 8 }}>
                                            <Grid container sx={{ pl: 3.2, pt: 1.5, pb: 1.6 }}>
                                                <div
                                                    style={{ float: "left", clear: "both" }}
                                                    ref={scrollStep2Ref}
                                                />
                                                <Typography sx={{ fontSize: '1.7rem', pb: 0.5 }}>2　依頼内容</Typography>
                                            </Grid>

                                            <Grid container sx={{ pl: 3.2, pb: 3.2 }}>
                                                <Grid container item xs="auto">
                                                    <Typography sx={{ fontSize: '1.5rem', mr: 1, pt: 0.5 }}>確認日：</Typography>
                                                    <Controller
                                                        name="requestDate"
                                                        control={control}
                                                        defaultValue=""
                                                        rules={validationRules.requestDate}
                                                        render={({ field: { onChange, value, ...restField }, formState: { errors } }) => (
                                                            <LocalizationProvider dateAdapter={AdapterDayjs} adapterLocale={ja}>
                                                                <DesktopDatePicker
                                                                    {...restField}
                                                                    inputFormat={'YYYY/MM/DD'}
                                                                    value={value || ''}
                                                                    onChange={(newDateValue) => {
                                                                        if (newDateValue) {
                                                                            onChange(dayjs(newDateValue).toDate())
                                                                        } else {
                                                                            onChange(newDateValue)
                                                                        }
                                                                    }}
                                                                    renderInput={(params) => (
                                                                        <TextField
                                                                            {...params}
                                                                            inputProps={{
                                                                                ...params.inputProps,
                                                                                maxLength: 10,
                                                                                style: { fontSize: '1.5rem', backgroundColor: '#f5f8fa' }
                                                                            }}
                                                                            variant="standard"
                                                                            label=""
                                                                            error={errors.requestDate ? true : false}
                                                                            helperText={errors.requestDate?.message}
                                                                        />
                                                                    )}
                                                                />
                                                            </LocalizationProvider>
                                                        )}
                                                    />
                                                </Grid>

                                                <Grid container item xs="auto">
                                                    <Typography sx={{ fontSize: '1.5rem', mr: 1, pl: 2.5, pt: 0.5 }}>受付者：</Typography>
                                                    <Controller
                                                        name="requestPerson"
                                                        control={control}
                                                        defaultValue=""
                                                        rules={validationRules.requestPerson}
                                                        render={({ field, fieldState }) => (
                                                            <TextField
                                                                {...field}
                                                                inputProps={{
                                                                    maxLength: 24,
                                                                    style: { fontSize: '1.5rem', backgroundColor: '#f5f8fa' }
                                                                }}
                                                                variant="standard"
                                                                error={fieldState.invalid}
                                                                sx={{ width: "60%" }}
                                                                helperText={fieldState.error?.message} />
                                                        )}
                                                    />
                                                </Grid>

                                                <Controller
                                                    name="requestContent"
                                                    control={control}
                                                    defaultValue=""
                                                    rules={validationRules.sagyoNaiyoRequest}
                                                    render={({ field, formState: { errors } }) => (
                                                        <TextField
                                                            {...field}
                                                            value={field.value ?? ""}
                                                            InputProps={{ style: { fontSize: '1.35rem', lineHeight: 1.5, overflow: 'hidden' } }}
                                                            sx={{ backgroundColor: '#f5f8fa' }}
                                                            fullWidth
                                                            multiline
                                                            minRows={sagyoNaiyoMaxRows.defaultRows}
                                                            onKeyDown={handleKeyDown(sagyoNaiyoMaxRows.request)}
                                                            placeholder={`50文字、${sagyoNaiyoMaxRows.request}行まで入力できます`}
                                                            error={errors.requestContent ? true : false}
                                                            helperText={errors.requestContent?.message}
                                                        />
                                                    )}
                                                />
                                            </Grid>

                                            <Grid container sx={{ pl: 3.2, pt: 1.5, pb: 3.2, mt: 2 }}>
                                                <div
                                                    style={{ float: "left", clear: "both" }}
                                                    ref={scrollStep3Ref}
                                                />
                                                <Typography sx={{ fontSize: '1.7rem', pb: 1.6 }}>3　確認した内容</Typography>
                                                <Controller
                                                    name="comfirmContent"
                                                    control={control}
                                                    defaultValue=""
                                                    rules={validationRules.sagyoNaiyoConfirm}
                                                    render={({ field, formState: { errors } }) => (
                                                        <TextField
                                                            {...field}
                                                            value={field.value ?? ""}
                                                            InputProps={{ style: { fontSize: '1.35rem', lineHeight: 1.5, overflow: 'hidden' } }}
                                                            sx={{ backgroundColor: '#f5f8fa' }}
                                                            fullWidth
                                                            multiline
                                                            minRows={sagyoNaiyoMaxRows.defaultRows}
                                                            onKeyDown={handleKeyDown(sagyoNaiyoMaxRows.confirm)}
                                                            placeholder={`50文字、${sagyoNaiyoMaxRows.confirm}行まで入力できます`}
                                                            error={errors.comfirmContent ? true : false}
                                                            helperText={errors.comfirmContent?.message}
                                                        />
                                                    )}
                                                />
                                            </Grid>

                                            <Grid container sx={{ pl: 3.2, pt: 1.5, pb: 3.2, mt: 2 }}>
                                                <div
                                                    style={{ float: "left", clear: "both" }}
                                                    ref={scrollStep4Ref}
                                                />
                                                <Typography sx={{ fontSize: '1.7rem', pb: 1.6 }}>4　本日の作業内容</Typography>

                                                <Grid container item direction='row' sx={{
                                                    pl: 3.2, pt: 1.5, pb: 1.5,
                                                    backgroundColor: shitenError ? inspectionTheme?.components?.MuiFormHelperText?.styleOverrides?.root?.backgroundColor : null,
                                                    borderRadius: 3
                                                }}>
                                                    {honjitsuSagyoList?.map((item, index) => {
                                                        return (
                                                            <Grid item xs={2.4} key={index}>
                                                                <Controller
                                                                    name={item.sagyoId}
                                                                    key={index}
                                                                    control={control}
                                                                    defaultValue=""
                                                                    render={({ field: { value } }) => (
                                                                        <FormControlLabel
                                                                            sx={{ pl: 3.2, }}
                                                                            control={
                                                                                <Checkbox
                                                                                    value={value ?? ""}
                                                                                    checked={getValues(item.sagyoId) === '1' ? true : false}
                                                                                    onChange={(event) => { handleCheckboxOnChange(event.target.checked, item.sagyoId, "sagyo") }}
                                                                                    sx={{ '& .MuiSvgIcon-root': { fontSize: '2rem' } }}
                                                                                />
                                                                            }
                                                                            label={<Typography sx={{ mr: 1, fontSize: '1.5rem' }}  >{item.sagyoName}</Typography>}
                                                                        />
                                                                    )}
                                                                />
                                                            </Grid>
                                                        );
                                                    })}
                                                </Grid>

                                                <Controller
                                                    name="todayContent"
                                                    control={control}
                                                    defaultValue=""
                                                    rules={validationRules.sagyoNaiyoCurrent}
                                                    render={({ field, formState: { errors } }) => (
                                                        <TextField
                                                            {...field}
                                                            value={field.value ?? ""}
                                                            InputProps={{ style: { fontSize: '1.35rem', lineHeight: 1.5, overflow: 'hidden' } }}
                                                            sx={{ backgroundColor: '#f5f8fa' }}
                                                            fullWidth
                                                            multiline
                                                            minRows={sagyoNaiyoMaxRows.defaultRows}
                                                            onKeyDown={handleKeyDown(sagyoNaiyoMaxRows.current)}
                                                            placeholder={`50文字、${sagyoNaiyoMaxRows.current}行まで入力できます`}
                                                            error={errors.todayContent ? true : false}
                                                            helperText={errors.todayContent?.message}
                                                        />
                                                    )}
                                                />
                                            </Grid>

                                            <Grid container sx={{ pl: 3.2, pt: 1.5, pb: 3.2, mt: 2 }}>
                                                <div
                                                    style={{ float: "left", clear: "both" }}
                                                    ref={scrollStep5Ref}
                                                />
                                                <Typography sx={{ fontSize: '1.7rem', pb: 1.6 }}>5　今後のスケジュールと作業内容</Typography>
                                                <Controller
                                                    name="schduleContent"
                                                    control={control}
                                                    defaultValue=""
                                                    rules={validationRules.sagyoNaiyoUpcoming}
                                                    render={({ field, formState: { errors } }) => (
                                                        <TextField
                                                            {...field}
                                                            value={field.value ?? ""}
                                                            InputProps={{ style: { fontSize: '1.35rem', lineHeight: 1.5, overflow: 'hidden' } }}
                                                            sx={{ backgroundColor: '#f5f8fa' }}
                                                            fullWidth
                                                            multiline
                                                            minRows={sagyoNaiyoMaxRows.defaultRows}
                                                            onKeyDown={handleKeyDown(sagyoNaiyoMaxRows.upcoming)}
                                                            placeholder={`50文字、${sagyoNaiyoMaxRows.upcoming}行まで入力できます`}
                                                            error={errors.schduleContent ? true : false}
                                                            helperText={errors.schduleContent?.message}
                                                        />
                                                    )}
                                                />
                                            </Grid>
                                        </Grid>
                                    </fieldset>
                                </FormControl >
                                <Grid container direction="column" >
                                    <fieldset disabled={!keyData.canEdit} style={{ border: 0, margin: 0, padding: 0 }} >
                                        <Grid container item component="main" sx={{ mt: 8 }}>
                                            <div
                                                style={{ float: "left", clear: "both" }}
                                                ref={scrollStep6Ref}
                                            />
                                            <Typography sx={{ pt: 3, fontSize: '2rem', }}>別紙打ち合わせ記録</Typography>
                                            <Grid sx={{ pt: 4, pl: 2 }}>
                                                <Controller
                                                    control={control}
                                                    name="besshiRecord"
                                                    render={({ field: { value, onChange } }) => (
                                                        //<Toggle
                                                        //    setCheckedToggle={onChange}
                                                        //    checkedToggle={parseInt(value)}
                                                        //    toggleValue={"無"}
                                                        //    toggleSts={TOGGLE_STATES.One}
                                                        //    toggleValue2={"有"}
                                                        //    toggleSts2={TOGGLE_STATES.Two}
                                                        ///>
                                                        <ToggleButtonGroup
                                                            id="besshiRecord"
                                                            value={value === "0" ? null : value}
                                                            exclusive
                                                            disabled={!keyData.canEdit}
                                                            sx={{
                                                                minWidth: 180,
                                                                minHeight: 10,
                                                                backgroundColor: "#289bdf",
                                                                color: "#FFFFFF",
                                                            }}
                                                            onChange={(event, newValue) => {
                                                                onChange(newValue === null ? "0" : newValue);
                                                            }}
                                                        >
                                                            <ToggleButton
                                                                value={"1"}
                                                                disabled={!keyData.canEdit}
                                                                sx={{
                                                                    minWidth: 95,
                                                                    fontSize: 18,
                                                                    padding: 0.6,
                                                                    bgcolor: "#F0F8FF",
                                                                    color: "#BBBBBB",
                                                                    "&.Mui-selected": {
                                                                        color: "#EEEEEE",
                                                                    },
                                                                    '&:hover': !keyData.canEdit
                                                                        ? {}
                                                                        : {
                                                                            backgroundColor: 'primary.light',
                                                                            color: '#EEEEEE'
                                                                        },
                                                                }}>
                                                                無
                                                            </ToggleButton>
                                                            <ToggleButton value={"2"}
                                                                sx={{
                                                                    minWidth: 95,
                                                                    fontSize: 18,
                                                                    padding: 0.6,
                                                                    bgcolor: "#F0F8FF",
                                                                    color: "#BBBBBB",
                                                                    "&.Mui-selected": {
                                                                        color: "#EEEEEE",
                                                                    },
                                                                    '&:hover': !keyData.canEdit
                                                                        ? {}
                                                                        : {
                                                                            backgroundColor: 'primary.light',
                                                                            color: '#EEEEEE'
                                                                        },
                                                                }}>
                                                                有
                                                            </ToggleButton>
                                                        </ToggleButtonGroup>
                                                    )}

                                                />
                                            </Grid>
                                            {/* InsFormFileUp 別紙打ち合わせ */}
                                            <InsFormFileUp
                                                elementId={'attatchedUchiawase'}
                                                fileTypeId={1}
                                                attachedImage={attachedImage}
                                                attachedPdf={attachedPdf}
                                                maxFileNum={3}
                                                keyData={keyData}
                                                previewImgIndex={previewImgIndex}
                                                previewImgDialog={previewImgDialog}
                                                previewImgCancelClick={previewImgCancelClick}
                                                prevDelIndex={prevDelIndex}
                                                previewImgDelDialog={previewImgDelDialog}
                                                previewCancelBack={previewCancelBack}
                                                previewPdfDelDialog={previewPdfDelDialog}
                                                setUploadFlag={setUploadFlag}
                                                setProcessing={setProcessing}
                                                showPreviewImg={showPreviewImg}
                                                previewImgDeleteClick={previewImgDeleteClick}
                                                previewPdfOnClick={previewPdfOnClick}
                                                previewPdfDeleteClick={previewPdfDeleteClick}
                                                setAttachedImage={setAttachedImage}
                                                setPreviewImgDelDialog={setPreviewImgDelDialog}
                                                setAttachedPdf={setAttachedPdf}
                                                setPreviewPdfDelDialog={setPreviewPdfDelDialog}
                                                canEdit={keyData.canEdit}
                                            />
                                        </Grid>

                                    </fieldset>
                                    <fieldset disabled={!keyData.canEdit} style={{ border: 0, margin: 0, padding: 0 }} >
                                        <Grid container component="main" sx={{ mt: 8 }}>
                                            <Typography sx={{ pt: 3, fontSize: '2rem', }}>別紙図面</Typography>
                                            <Grid sx={{ pt: 4, pl: 2 }}>
                                                <Controller
                                                    control={control}
                                                    name="besshizumen"
                                                    render={({ field: { value, onChange } }) => (
                                                        <>
                                                            {/*
                                                    <Toggle
                                                        setCheckedToggle={onChange}
                                                        checkedToggle={parseInt(value)}
                                                        toggleValue={"無"}
                                                        toggleSts={TOGGLE_STATES.One}
                                                        toggleValue2={"有"}
                                                        toggleSts2={TOGGLE_STATES.Two}
                                                        disabled={!keyData.canEdit}
                                                        />
                                                        */}
                                                            <ToggleButtonGroup
                                                                id="besshizumen"
                                                                value={value === "0" ? null : value}
                                                                exclusive
                                                                disabled={!keyData.canEdit}
                                                                sx={{
                                                                    minWidth: 180,
                                                                    minHeight: 10,
                                                                    backgroundColor: "#289bdf",
                                                                    color: "#FFFFFF",
                                                                }}
                                                                onChange={(event, newValue) => {
                                                                    onChange(newValue === null ? "0" : newValue);
                                                                }}
                                                            >
                                                                <ToggleButton
                                                                    value={"1"}
                                                                    disabled={!keyData.canEdit}
                                                                    sx={{
                                                                        minWidth: 95,
                                                                        fontSize: 18,
                                                                        padding: 0.6,
                                                                        bgcolor: "#F0F8FF",
                                                                        color: "#BBBBBB",
                                                                        "&.Mui-selected": {
                                                                            color: "#EEEEEE",
                                                                        },
                                                                        '&:hover': !keyData.canEdit
                                                                            ? {}
                                                                            : {
                                                                                backgroundColor: 'primary.light',
                                                                                color: '#EEEEEE'
                                                                            },
                                                                    }}>
                                                                    無
                                                                </ToggleButton>
                                                                <ToggleButton value={"2"}
                                                                    sx={{
                                                                        minWidth: 95,
                                                                        fontSize: 18,
                                                                        padding: 0.6,
                                                                        bgcolor: "#F0F8FF",
                                                                        color: "#BBBBBB",
                                                                        "&.Mui-selected": {
                                                                            color: "#EEEEEE",
                                                                        },
                                                                        '&:hover': !keyData.canEdit
                                                                            ? {}
                                                                            : {
                                                                                backgroundColor: 'primary.light',
                                                                                color: '#EEEEEE'
                                                                            },
                                                                    }}>
                                                                    有
                                                                </ToggleButton>
                                                            </ToggleButtonGroup>
                                                        </>
                                                    )}

                                                />
                                            </Grid>
                                            <InsFormFileUp
                                                elementId={'attatchedZumen'}
                                                fileTypeId={0}
                                                attachedImage={attachedImage}
                                                attachedPdf={attachedPdf}
                                                maxFileNum={3}
                                                keyData={keyData}
                                                previewImgIndex={previewImgIndex}
                                                previewImgDialog={previewImgDialog}
                                                previewImgCancelClick={previewImgCancelClick}
                                                prevDelIndex={prevDelIndex}
                                                previewImgDelDialog={previewImgDelDialog}
                                                previewCancelBack={previewCancelBack}
                                                previewPdfDelDialog={previewPdfDelDialog}
                                                setUploadFlag={setUploadFlag}
                                                setProcessing={setProcessing}
                                                showPreviewImg={showPreviewImg}
                                                previewImgDeleteClick={previewImgDeleteClick}
                                                previewPdfOnClick={previewPdfOnClick}
                                                previewPdfDeleteClick={previewPdfDeleteClick}
                                                setAttachedImage={setAttachedImage}
                                                setPreviewImgDelDialog={setPreviewImgDelDialog}
                                                setAttachedPdf={setAttachedPdf}
                                                setPreviewPdfDelDialog={setPreviewPdfDelDialog}
                                                canEdit={keyData.canEdit}
                                            />
                                        </Grid>

                                    </fieldset>
                                    <fieldset disabled={!keyData.canEdit} style={{ border: 0, margin: 0, padding: 0 }} >
                                        <Grid container item component="main" sx={{ mt: 8 }}>
                                            <Typography sx={{ pt: 3, fontSize: '2rem', }}>撮影画像</Typography>
                                            <InsFormFileUp
                                                elementId={'attatchedSatsuei'}
                                                fileTypeId={2}
                                                attachedImage={attachedImage}
                                                attachedPdf={attachedPdf}
                                                maxFileNum={20}
                                                keyData={keyData}
                                                previewImgIndex={previewImgIndex}
                                                previewImgDialog={previewImgDialog}
                                                previewImgCancelClick={previewImgCancelClick}
                                                prevDelIndex={prevDelIndex}
                                                previewImgDelDialog={previewImgDelDialog}
                                                previewCancelBack={previewCancelBack}
                                                previewPdfDelDialog={previewPdfDelDialog}
                                                setUploadFlag={setUploadFlag}
                                                setProcessing={setProcessing}
                                                showPreviewImg={showPreviewImg}
                                                previewImgDeleteClick={previewImgDeleteClick}
                                                previewPdfOnClick={previewPdfOnClick}
                                                previewPdfDeleteClick={previewPdfDeleteClick}
                                                setAttachedImage={setAttachedImage}
                                                setPreviewImgDelDialog={setPreviewImgDelDialog}
                                                setAttachedPdf={setAttachedPdf}
                                                setPreviewPdfDelDialog={setPreviewPdfDelDialog}
                                                canEdit={keyData.canEdit}
                                            />
                                        </Grid>

                                    </fieldset>
                                </Grid>
                                <Grid container sx={{ pl: 3.2, pt: 1.5, pb: 3.2 }}>
                                    <Typography sx={{ fontSize: '1.5rem', pt: 0.5, pb: 0.5 }}>点検記録に関しましては、弊社プライバシーポリシーに基づいて厳重に管理してまいります。</Typography>
                                    <Typography sx={{ fontSize: '1.5rem', pt: 0.5, pb: 1 }}>＊リフォーム工事のご用命は、スウェーデンハウスリフォームをご紹介させて頂きます。</Typography>
                                </Grid>

                                <FormControl disabled={!keyData.canEdit}  >
                                    <fieldset disabled={!keyData.canEdit} style={{ border: 0, margin: 0, padding: 0 }} >
                                        <Grid container component="main" >
                                            <Grid container item sx={{ pl: 3.2, pt: 1.5, }} >
                                                <Typography sx={{ fontSize: '1.5rem' }}>お問い合わせ等は、下記担当部門にお願いします。</Typography>
                                            </Grid>
                                            <div
                                                style={{ float: "left", clear: "both" }}
                                                ref={scrollStepShitenRef}
                                            />
                                            <Grid container item direction='row' sx={{
                                                pl: 3.2, pt: 1.5, pb: 1.5,
                                                backgroundColor: shitenError ? inspectionTheme?.components?.MuiFormHelperText?.styleOverrides?.root?.backgroundColor : null,
                                                borderRadius: 3
                                            }}>
                                                {shitenList?.map((item, index) => {
                                                    return (
                                                        <Grid item xs={3} key={index}>
                                                            <Controller
                                                                name={item.shitenId}
                                                                key={index}
                                                                control={control}
                                                                defaultValue=""
                                                                render={({ field: { value } }) => (
                                                                    <FormControlLabel
                                                                        sx={{ pl: 3.2, }}
                                                                        control={
                                                                            <Checkbox
                                                                                value={value ?? ""}
                                                                                checked={getValues(item.shitenId) === '1' ? true : false}
                                                                                onChange={(event) => { handleCheckboxOnChange(event.target.checked, item.shitenId, "shiten") }}
                                                                                sx={{ '& .MuiSvgIcon-root': { fontSize: '2rem' } }}
                                                                            />
                                                                        }
                                                                        label={<Typography sx={{ mr: 1, fontSize: '1.5rem' }}  >{item.shitenName}</Typography>}
                                                                    />
                                                                )}
                                                            />
                                                        </Grid>
                                                    );
                                                })}
                                            </Grid>
                                            <Grid container sx={{ pl: 3.2, pt: 1.5 }} >
                                                <Typography sx={{ fontSize: '1.5rem', }}>スウェーデンハウスパートナーシステム提携店</Typography>
                                            </Grid>
                                            <Grid container direction='row' sx={{
                                                pl: 3.2, pt: 1.5, pb: 1.5,
                                                borderRadius: 3
                                            }}>
                                                {partnerList?.map((item, index) => {
                                                    return (
                                                        <Grid item xs={3} key={index}>
                                                            <Controller
                                                                name={item.partnerId}
                                                                control={control}
                                                                defaultValue=""
                                                                render={({ field: { value } }) => (
                                                                    <FormControlLabel
                                                                        sx={{ pl: 3.2, }}
                                                                        control={
                                                                            <Checkbox
                                                                                value={value ?? ""}
                                                                                checked={getValues(item.partnerId) === '1' ? true : false}
                                                                                onChange={(event) => { handleCheckboxOnChange(event.target.checked, item.partnerId, "partner") }}
                                                                                sx={{ '& .MuiSvgIcon-root': { fontSize: '2rem' } }}
                                                                            />
                                                                        }
                                                                        label={<Typography sx={{ mr: 1, fontSize: '1.5rem' }}  >{item.partnerName}</Typography>}
                                                                    />
                                                                )}
                                                            />
                                                        </Grid>
                                                    );
                                                })}
                                            </Grid>
                                        </Grid>
                                    </fieldset>
                                </FormControl >
                            </Grid>
                        </InspectionContents>
                    </Grid >
                    :
                    <Grid>
                        <Grid sx={{ height: '4.5rem' }} />
                        <CssBaseline />
                        <Grid sx={{ background: '#f8f7f6', boxShadow: 0 }} style={{ position: "relative", }}>
                            <InspectionContents >
                                <Grid container columns={12} spacing={3} sx={{ alignItems: 'center' }}>
                                    <Grid item xs={2.5} >
                                        <Typography sx={{ fontSize: '1.5rem', color: '#000000', mt: 3, mb: 1 }} >
                                            工事コード:{keyData?.kojiCD}
                                        </Typography>
                                    </Grid>
                                    <Grid item xs={7} sx={{ pl: 1 }}>
                                        {keyData.thokiYuryoFlg === 1 ?
                                            <InspectionName style={{ display: 'flex', paddingBottom: 0, justifyContent: 'center', }}>
                                                <Typography sx={{ fontSize: '1.3rem', color: '#000000', mt: 3, mb: 1 }}>
                                                    <Box
                                                        component="span"
                                                        sx={{
                                                            fontSize: "1.3rem",
                                                            fontWeight: 600,
                                                            mr: 1,
                                                            color: "#2e7d32",
                                                            backgroundColor: "transparent",

                                                            cursor: "default",
                                                            userSelect: "none",
                                                        }}>
                                                        【長期優良住宅】
                                                    </Box>
                                                    {keyData?.teimei}
                                                </Typography>
                                            </InspectionName>
                                            :
                                            <InspectionName style={{ display: 'flex', paddingBottom: 0, justifyContent: 'center', }}>
                                                <Typography sx={{ fontSize: '1.3rem', color: '#000000', mt: 3, mb: 1 }}>
                                                    {keyData?.teimei}
                                                </Typography>
                                            </InspectionName>
                                        }
                                    </Grid>
                                    {!keyData.canEdit &&
                                        <Grid item xs={2.5} sx={{ pl: 1, justifyContent: "flex-end", }}>
                                            <InspectionName style={{ display: 'flex', paddingBottom: 0, justifyContent: 'center', }}>
                                                <Typography sx={{ fontSize: '1.3rem', color: '#000000' }}>
                                                    読み取り専用
                                                </Typography>
                                            </InspectionName>
                                        </Grid>
                                    }
                                </Grid>
                                <Contents component="main" sx={{ mb: 1 }}>
                                    <Steppers activeStep={activeStep} sx={{ pb: 1 }}>
                                        {PageSteps.map((label, index) => (
                                            <Step key={label} onClick={() => onStepClick(index)}>
                                                <StepLabel >{label}</StepLabel>
                                            </Step>
                                        ))}
                                    </Steppers>
                                </Contents>

                            </InspectionContents>
                        </Grid>
                        <InspectionContents sx={{ pt: 2, pb: 2 }}>
                            <fieldset disabled={!keyData.canEdit} style={{ border: 0, margin: 0, padding: 0 }} >
                                <Grid component="main" >
                                    <div
                                        style={{ float: "left", clear: "both" }}
                                        ref={scrollStep1Ref}
                                    />
                                    <Card sx={{ boxShadow: 0, minWidth: 300, }} style={{ backgroundColor: '#f8f7f6' }}>
                                        <CardContent>
                                            <Grid container spacing={2}>
                                                <Grid item xs={6} sx={{ textAlign: 'center' }}>
                                                    <UserInputData.Provider value={{ currentState, setCurrentState }}>
                                                        <CustomerSignature keyData={keyData} signClose={signClose} />
                                                    </UserInputData.Provider>
                                                    {signCustomer === false ?
                                                        <Typography sx={{ color: "#FF0000", pt: 1 }} >
                                                            お客様サインは必須です
                                                        </Typography> : ""
                                                    }
                                                </Grid>
                                                <Grid item xs={6} sx={{ textAlign: 'center' }}>
                                                    <UserInputData.Provider value={{ currentState, setCurrentState }}>
                                                        <TantoSignature keyData={keyData} signClose={signClose} />
                                                    </UserInputData.Provider>
                                                    {signTanto === false ?
                                                        <Typography sx={{ color: "#FF0000", pt: 1 }} >
                                                            担当者サインは必須です
                                                        </Typography> : ""
                                                    }
                                                </Grid>
                                            </Grid>
                                        </CardContent>
                                    </Card>
                                    <Grid sx={{ maxWidth: '100%', }}>
                                        <PdfViewerFrame pdfUrl={tenkenPdf} />
                                    </Grid>
                                </Grid>
                            </fieldset >
                        </InspectionContents>
                        <InspectionContents>
                            <Grid container sx={{ justifyContent: "flex-end", my: 3 }}>
                                <Grid>
                                    <GrayButton
                                        variant="contained"
                                        color="primary"
                                        size="large"
                                        type="button"
                                        sx={{ ml: 2, mr: 2, pt: 1.5, pb: 1.5, pl: 4, pr: 4, fontSize: '1.2rem' }}
                                        onClick={() => onSubmit("back")}>
                                        <ReplyAllIcon sx={{ mr: 2, fontSize: '2rem' }} />
                                        戻る
                                    </GrayButton>
                                    <NomalButton
                                        variant="contained"
                                        color="primary"
                                        size="large"
                                        type="button"
                                        sx={{ ml: 2, mr: 2, pt: 1.5, pb: 1.5, pl: 4, pr: 4, fontSize: '1.2rem' }}
                                        disabled={!signTanto || !signCustomer || !keyData.canEdit}
                                        onClick={() => onSubmit("save")}>
                                        <UploadIcon sx={{ mr: 2, fontSize: '2rem' }} />
                                        作成
                                    </NomalButton>
                                </Grid>
                            </Grid>
                        </InspectionContents>
                    </Grid>
                }
            </form >
        </ThemeProvider >
    );
}

/*import React from 'react';
import Grid from '@mui/material/Grid';
import Button from '@mui/material/Button';
import LoadingDialog from '../../Loading';
import { useForm } from "react-hook-form";
import { useNavigate, useLocation } from 'react-router-dom';

export default function WarrantyForm() {
    const pathName = useLocation().pathname;
    const step = pathName.split("/").slice(-1)[0];


    const navigate = useNavigate();
    const onSubmit = (action) => {
        if (action === "post") {
            navigate("/inspection/visitReport/customerlist/Reportlist");
        } else if (action === "next") {
            navigate("/inspection/visitReport/confirm");
        } else if (action === "save") {
            navigate("/inspection/visitReport/visitReport");
        } else if (action === "back") {
            navigate("/inspection/visitReport/edit");
        }
    };
    const handleSubmit = useForm();
    return (
        <React.Fragment>
            <Grid container columns={12} rowSpacing={3} columnSpacing={{ xs: 1, sm: 3, md: 3 }} sx={{ pt: 2 }}>
                <Grid container columns={16} rowSpacing={3} columnSpacing={{ xs: 1, sm: 3, md: 3 }} sx={{ pt: 5 }}>
                    <Grid item xs={14} >
                        <Button variant="contained" color="primary" size="large" type="button" onClick={() => onSubmit("post")}>
                            保存して一覧へ
                        </Button>
                        <LoadingDialog />

                    </Grid>
                    <Grid item xs={2}>
                        {step === 'edit' ?
                            <Button variant="contained" color="primary" size="large" type="button" onClick={() => onSubmit("next")}>
                                次へ
                            </Button>
                            : step === 'confirm' ?
                                <Grid item xs={14} >
                                    <Button variant="contained" color="primary" size="large" type="button" onClick={() => onSubmit("back")}>
                                        戻る
                                    </Button>
                                    <Button variant="contained" color="primary" size="large" type="button" onClick={() => onSubmit("save")}>
                                        作成
                                    </Button>
                                </Grid>
                                : null}

                    </Grid>
                </Grid>
            </Grid>
        </React.Fragment>
    );
}*/

